import { TEST } from "../actions/types";

const INITIAL_STATE = { test: "OK" };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TEST:
            //console.log("Respuesta Reducer", action);
            return { ...action.payload };
        default:
            return state;
    }
};
